import api from '../../../../api';

export interface GroupedPinnedMaterial {
  [moduleId: string]: {
    medialinks: string[];
    whitepages: string[];
    userMaterial: string[];
    slideSets: number[];
  };
}

export interface PinnedMaterial {
  medialinks: string[];
  whitepages: string[];
  userMaterial: string[];
  slideSets: number[];
}

export interface PinnedMaterialItem {
  materialId: string | number;
  materialType: PinnedMaterialTypeParam;
}

export type PinnedMaterialTypeParam = 'MEDIALINK' | 'WHITEPAGE' | 'USER_MATERIAL' | 'SLIDE_SET';

export async function getPinnedMaterial(moduleId: string, includeSubModules = false): Promise<GroupedPinnedMaterial> {
  const query = new URLSearchParams();
  if (includeSubModules) query.append('includeSubModules', 'true');

  const { data } = await api.get(`/studio/user/modules/${moduleId}/pinned-material?${query}`);
  return data;
}

export async function postPinnedMaterials(moduleId: string, materials: PinnedMaterialItem[]): Promise<void> {
  await api.post(`/studio/user/modules/${moduleId}/pinned-materials`, { materials });
}

export async function deletePinnedMaterials(moduleId: string, materials: PinnedMaterialItem[]): Promise<void> {
  await api.delete(`/studio/user/modules/${moduleId}/pinned-materials`, { data: { materials } });
}
